var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.917969,
    width: 43.4301,
    height: 43.4301,
    rx: 21.715,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9812 26.9253C25.2193 26.9253 27.8443 24.3004 27.8443 21.0623C27.8443 17.8242 25.2193 15.1992 21.9812 15.1992C18.7431 15.1992 16.1182 17.8242 16.1182 21.0623C16.1182 24.3004 18.7431 26.9253 21.9812 26.9253Z",
    stroke: "#605BFF",
    strokeWidth: 1.3029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.17 28.2288C28.7097 28.2288 29.1472 27.7913 29.1472 27.2516C29.1472 26.7119 28.7097 26.2744 28.17 26.2744C27.6304 26.2744 27.1929 26.7119 27.1929 27.2516C27.1929 27.7913 27.6304 28.2288 28.17 28.2288Z",
    stroke: "#605BFF",
    strokeWidth: 1.3029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchimg);
export default __webpack_public_path__ + "static/media/searchimg.9e3231b55fd5b066bcde6763edba3230.svg";
export { ForwardRef as ReactComponent };